<template>
	<li class="list_item">
		<a :href="cafeLink" class="link_item thumb_info_type" target="_blank">
			<div class="box_num">
				<span class="num_item">{{ rank + 1 }}</span>
			</div>
			<div class="wrap_thumb">
				<img :src="cafeImage" class="img_thumb" alt="">
				<div class="tag_cafe_ico">
					<span v-if="cafeInfo.gameCafe" class="svg_game"><span class="sr_only">게임카페</span></span>
				    <span v-else-if="cafeInfo.popularCafe" class="svg_great"><span class="sr_only">인기카페</span></span>
					<span v-else-if="cafeInfo.officialFanCafe" class="svg_fan"><span class="sr_only">팬카페</span></span>
				</div>
			</div>
			<div class="wrap_info" :class="infoClass">
				<strong class="tit_name">{{ cafeInfo.grpname }}</strong>
				<p class="desc_cafe">{{ cafeInfo.grpdesc }}</p>
				<div class="tag_type_info">
					<span class="txt_info">{{ cafeInfo.cafeLevelName }} {{ cafeInfo.cafeLevel }}단계</span>
					<span class="txt_info"><em class="screen_out">점수</em>{{ cafeScore }}점</span>
					<span class="txt_info"><em>회원수 </em>{{ cafeMemberCnt }}</span>
				</div>
			</div>
		</a>
	</li>
</template>

<script>
export default {
	props: ['rank', 'cafeInfo'],
	computed: {
		cafeLink() {
			return `https://cafe.daum.net/${this.cafeInfo.grpcode}`;
		},
		cafeImage() {
			return this.cafeInfo.cafeImage
				? `//img1.daumcdn.net/thumb/C151x151/?fname=${this.cafeInfo.cafeImage}`
				: '//img1.daumcdn.net/thumb/C151x151/?fname=https://t1.daumcdn.net/cafe_image/20240314/cafe-de.png';
		},
		cafeScore() {
			return this.formatNumber(this.cafeInfo.cafeScore);
		},
		cafeMemberCnt() {
			return this.formatNumber(this.cafeInfo.totalMemberCount);
		},
		infoClass() {
			return { empty: !this.cafeInfo.grpdesc }
		}
	},

	methods: {
		formatNumber(n) {
			return n.toLocaleString();
		}
	}
}
</script>
